import React from "react";

export interface ITaskContext {
  abilities: string[];
}
export const AbitlityContext = React.createContext<ITaskContext>(null);

export default AbitlityContext;
